module.exports = __webpack_public_path__ + "img/88.349794fa.jpg";